import { z } from 'zod';
// How often a commitment is billed: once per month or once for the whole of it.
export const subscriptionBillingCadenceSchema = z.enum(['Monthly', 'Upfront']);
export const SubscriptionBillingCadence = subscriptionBillingCadenceSchema.enum;
